import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";

const NorthEastMap = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { getText } = useLanguageTranslation();

  useEffect(() => {
    let script1, script2, script3, script4;

    if (languageType === "") {
      // English scripts
      script1 = document.createElement("script");
      script1.src = "/js/mapdata.js";
      script1.async = true;

      script2 = document.createElement("script");
      script2.src = "/js/countrymap.js";
      script2.async = true;

      document.head.appendChild(script1);
      document.head.appendChild(script2);
    } else if (languageType === "hi") {
      // Hindi scripts
      script3 = document.createElement("script");
      script3.src = "/js/mapdataHindi.js";
      script3.async = true;

      script4 = document.createElement("script");
      script4.src = "/js/countrymapHindi.js";
      script4.async = true;

      document.head.appendChild(script3);
      document.head.appendChild(script4);
    }

    return () => {
      // Clean up the scripts when the component unmounts
      if (script1 && script2) {
        document.head.removeChild(script1);
        document.head.removeChild(script2);
      }
      if (script3 && script4) {
        document.head.removeChild(script3);
        document.head.removeChild(script4);
      }
    };
  }, [languageType]);

  return (
    <>
      <a
        className="cursor-none"
        href="#"
        onClick={(e) => {
          e.preventDefault();
        }}
      >
        <details className="visually-hidden">
          <summary>
            {getText(
              "North East India Map Details",
              "उत्तर पूर्व भारत का मानचित्र विवरण",
            )}
          </summary>
          <p>
            {getText(
              "Interactive map showing NEEPCO's power infrastructure across North East India",
              "उत्तर पूर्व भारत में नीपको की बिजली संरचना दिखाने वाला इंटरएक्टिव नक्शा",
            )}
          </p>
          <ul>
            {/* <li>
              {getText(
                "Click on states to view details",
                "विवरण देखने के लिए राज्यों पर क्लिक करें"
              )}
            </li> */}
            <li>
              {getText(
                "Color-coded by power generation capacity",
                "बिजली उत्पादन क्षमता के अनुसार रंग-कोडित",
              )}
            </li>
            <li>
              {getText(
                "Includes hydro, thermal, and solar plants",
                "जलविद्युत, तापीय और सौर संयंत्र शामिल हैं",
              )}
            </li>
          </ul>
        </details>
        <div className="power-generation-box wow zoomIn">
          <div className="map-sec-home">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 map-heading">
              <p>
                {getText(
                  "Hover over the North Eastern region to view project details",
                  "परियोजना विवरण देखने के लिए उत्तर पूर्वी क्षेत्र पर माउस घुमाएँ",
                )}
              </p>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <div className="map-sec">
                <div
                  id="map"
                  role="img"
                  aria-label={getText(
                    "Interactive map of North East India showing NEEPCO power infrastructure",
                    "नीपको बिजली संरचना दिखाने वाला उत्तर पूर्व भारत का इंटरएक्टिव नक्शा",
                  )}
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div className="visually-hidden">
          {/* <p>
            {getText(
              "Use keyboard arrow keys to navigate the map or tab to select regions",
              "मानचित्र पर नेविगेट करने के लिए कीबोर्ड तीर कुंजियों का उपयोग करें या क्षेत्रों का चयन करने के लिए टैब करें"
            )}
          </p> */}
        </div>
      </a>
    </>
  );
};

export default NorthEastMap;
